// extracted by mini-css-extract-plugin
export var dropdownIcon = "_si-6";
export var imgContainer = "_si-3";
export var menuIcon = "_si-5";
export var pillWrapper = "_si-2";
export var pillsContainer = "_si-1";
export var subscriptionCard = "_si-0";
export var subscriptionLogo = "_si-4";